import moment from 'moment-timezone';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import ChairRentalHistory from '../components/ChairRentalHistory';
import { getChairRentalPaymentHistory } from '../selector';
import { fetchChairRentalPaymentHistory } from '../actions';
import withTimezone from '../../../../auth/utils/withTimezone';

const mapStateToProps = state => ({
  chairRentalPaymentHistory: getChairRentalPaymentHistory(state),
});

const mapDispatchToProps = {
  fetchChairRentalPaymentHistory,
};

export default compose(
  withTimezone,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    fetchForMonth: props => (month) => {
      return props.fetchChairRentalPaymentHistory(
        props.chairRental.barberId,
        moment.tz(month, props.timezone).format('YYYY-MM-DD'),
      );
    },
  }),
)(ChairRentalHistory);
